export default "__VITE_ASSET__2nWs4dZM__"